/*
// Vanilla
var httpRequest = new XMLHttpRequest()
httpRequest.onreadystatechange = function (data) {
  // code
}
httpRequest.open('GET', 'http://ajax.googleapis.com/ajax/libs/jquery/1/jquery.min.js');
httpRequest.send();
var timeout = ( function(){ var timers = {}; return function( callback, ms, x_id ){ if ( !x_id ){ x_id = ''; } if ( timers[x_id] ){ clearTimeout( timers[x_id] ); } timers[x_id] = setTimeout( callback, ms ); }; })()
jQuery(document).ready(function ($) {
  var stickyscroll = 0;
        var goTopBtn = document.querySelector('.back-to-top');
  if( $('.sticky-bar').length ) {
    stickyscroll = $(".sticky-bar").offset().top;
  }  
  $('.faq-q').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {
    });
  });
  $( 'a' ).click( function(e){
    if( this.hash && $( this.hash ).offset() ){
      e.preventDefault();
      window.scrollTo({
        top: $( this.hash ).offset().top, 
        behavior: 'smooth'
      });
    }      
  });
  $('.click-here').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {});
  });
  $('.menu-icon i').click(function () {
    $(this).toggleClass('active');
    $('.toggle-menu-wrap').slideToggle("slow", function () {});
  });
  if ( $('#owl-carousel2').length ) {
    $("#owl-carousel2").owlCarousel({
      loop: true,
      items: 1,
      nav:true,
      slideSpeed: 2000,
      autoplay: true,
      thumbs: true,
      dots: false,
      thumbImage: true,
      thumbContainerClass: "owl-thumbs",
      thumbItemClass: "owl-thumb-item"
    });
  }
  if ( $('.lp-owlCarousel').length ) {
    $('.lp-owlCarousel').owlCarousel({
        loop: false,
        nav: false,
        dots: false,
        margin: 24,
        autoHeight: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true,
                dots: false
            },
            901: {
                items: 4,
                nav: true,
                dots: false
            }
        }
    });
  }
  if ( window.innerWidth > 1023 ) {
    if ( $( window ).scrollTop() > stickyscroll && $('.sticky-bar').length ) {
      $(".sticky-bar").addClass('active');
    }
    if ( $( window ).scrollTop() < stickyscroll && $('.sticky-bar').length ) {
       $(".sticky-bar").removeClass('active');
    } 
  }
  $( window ).scroll(function(){
    timeout( function(){
      if ( window.innerWidth > 1023 ) {
        if ( $( window ).scrollTop() > stickyscroll && $('.sticky-bar').length ) {
          $(".sticky-bar").addClass('active');
        }
        if ( $( window ).scrollTop() < stickyscroll && $('.sticky-bar').length ) {
           $(".sticky-bar").removeClass('active');
        } 
      }      
        if ($( window ).scrollTop() > $( ".product-single__form button.add-to-cart" ).offset().top ) {
          if ( $('#BackToTop').length ) {
            $('#BackToTop').show();
          }
        }
        if ($( window ).scrollTop() < $( ".product-single__form button.add-to-cart" ).offset().top ) {
          if ( $('#BackToTop').length ) {
            $('#BackToTop').hide();
          }
        }
    }, 10 );
  });
  $('.back-to-top-btn').click(function(){
        $("html, body").animate({ scrollTop: $( "form.product-single__form" ).offset().top }, 400);   
  });
  $('.yt').click(function(){
    autoPlayVideo($(this).attr('ytid'));
  });
  function autoPlayVideo(vcode){
    "use strict";
    $('.yt').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+vcode+'?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe>');
  }
  loop();
  mslider();
  $( window ).resize( function(){
      timeout( function(){
        loop();
        mslider();
      }, 200 );
  });
  $(window).bind('load',function() {
    if ( $('#carousel').length ) {
      $('#carousel').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 210,
        itemMargin: 5,
        asNavFor: '#slider'
      });
    }
    if ( $('#slider').length ) {
      $('#slider').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        sync: "#carousel"
      });
    }
  });
  function loop(){
    if($('.loop').length && window.innerWidth < 1024){
      $('.loop').owlCarousel({
        center: true,
        items:1,
        loop:true,
        nav: true,
        dots: false
      });
    }else{
      if($('.loop').length){$('.loop').owlCarousel('destroy');}
    }
  }
  function mslider(){
    if($('.m-slider').length && window.innerWidth < 1024){
      $('.m-slider').addClass( 'owl-carousel owl-theme' );
      $('.m-slider').owlCarousel({
        center: true,
        items:1,
        loop:false,
        nav: true,
        dots: true
      });
    }else{
      if($('.m-slider').length){$('.m-slider').owlCarousel('destroy');
      $('.m-slider').removeClass( 'owl-carousel owl-theme' );}
    }
  }

$(document).ready(function(){
  $(".rc_widget__option__input--onetime, .rc_widget__option__input--subsave").click(function(){
    $(".p-price").hide();
  });
}); 
  
  var rechargeWidgetText = setInterval(function() {
    if($('.rc-option__subsave').length) {
      if(typeof theme.settings.rechargeWidgetText != 'undefined') {
        var settingText = theme.settings.rechargeWidgetText;
        var html = `<div class="productlisttext" style="display: none;">${settingText}</div>`;
      }

      $('.rc-option__subsave').append(html);
      $('.rc-radio__input').change(function() {
        if($(this).val() == 'subsave') {
          $('.rc-option__subsave .productlisttext').show();
        } else {
          $('.rc-option__subsave .productlisttext').hide();
        }
      });

      $('.rc_popup').remove();
      clearInterval(rechargeWidgetText);
    }
  }, 100);
});
*/
var httpRequest=new XMLHttpRequest;httpRequest.onreadystatechange=function(t){},httpRequest.open("GET","http://ajax.googleapis.com/ajax/libs/jquery/1/jquery.min.js"),httpRequest.send();var timeout=function(){var t={};return function(o,e,s){s||(s=""),t[s]&&clearTimeout(t[s]),t[s]=setTimeout(o,e)}}();jQuery(document).ready(function(t){var o=0;function e(){t(".loop").length&&window.innerWidth<1024?t(".loop").owlCarousel({center:!0,items:1,loop:!0,nav:!0,dots:!1}):t(".loop").length&&t(".loop").owlCarousel("destroy")}function s(){t(".m-slider").length&&window.innerWidth<1024?(t(".m-slider").addClass("owl-carousel owl-theme"),t(".m-slider").owlCarousel({center:!0,items:1,loop:!0,nav:!0,dots:!0})):t(".m-slider").length&&(t(".m-slider").owlCarousel("destroy"),t(".m-slider").removeClass("owl-carousel owl-theme"))}document.querySelector(".back-to-top"),t(".sticky-bar").length&&(o=t(".sticky-bar").offset().top),t(".faq-q").click(function(){t(this).toggleClass("active");var o=t(this).next();t(o).slideToggle("slow",function(){})}),t("a").click(function(o){this.hash&&t(this.hash).offset()&&(o.preventDefault(),window.scrollTo({top:t(this.hash).offset().top,behavior:"smooth"}))}),t(".click-here").click(function(){t(this).toggleClass("active");var o=t(this).next();t(o).slideToggle("slow",function(){})}),t(".menu-icon i").click(function(){t(this).toggleClass("active"),t(".toggle-menu-wrap").slideToggle("slow",function(){})}),t("#owl-carousel2").length&&t("#owl-carousel2").owlCarousel({loop:!0,items:1,nav:!0,slideSpeed:2e3,autoplay:!0,thumbs:!0,dots:!1,thumbImage:!0,thumbContainerClass:"owl-thumbs",thumbItemClass:"owl-thumb-item"}),t(".lp-owlCarousel").length&&t(".lp-owlCarousel").owlCarousel({loop:!1,nav:!1,dots:!1,margin:24,autoHeight:!0,responsiveClass:!0,responsive:{0:{items:1,nav:!0,dots:!1},901:{items:4,nav:!0,dots:!1}}}),window.innerWidth>1023&&(t(window).scrollTop()>o&&t(".sticky-bar").length&&t(".sticky-bar").addClass("active"),t(window).scrollTop()<o&&t(".sticky-bar").length&&t(".sticky-bar").removeClass("active")),t(window).scroll(function(){timeout(function(){window.innerWidth>1023&&(t(window).scrollTop()>o&&t(".sticky-bar").length&&t(".sticky-bar").addClass("active"),t(window).scrollTop()<o&&t(".sticky-bar").length&&t(".sticky-bar").removeClass("active")),t(window).scrollTop()>t(".product-single__form button.add-to-cart").offset().top&&t("#BackToTop").length&&t("#BackToTop").show(),t(window).scrollTop()<t(".product-single__form button.add-to-cart").offset().top&&t("#BackToTop").length&&t("#BackToTop").hide()},10)}),t(".back-to-top-btn").click(function(){t("html, body").animate({scrollTop:t("form.product-single__form").offset().top},400)}),t(".yt").click(function(){var o;o=t(this).attr("ytid"),t(".yt").html('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+o+'?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe>')}),e(),s(),t(window).resize(function(){timeout(function(){e(),s()},200)}),t(window).bind("load",function(){t("#carousel").length&&t("#carousel").flexslider({animation:"slide",controlNav:!1,animationLoop:!1,slideshow:!1,itemWidth:210,itemMargin:5,asNavFor:"#slider"}),t("#slider").length&&t("#slider").flexslider({animation:"slide",controlNav:!1,animationLoop:!1,slideshow:!1,sync:"#carousel"})}),t(document).ready(function(){t(".rc_widget__option__input--onetime, .rc_widget__option__input--subsave").click(function(){t(".p-price").hide()})});var i=setInterval(function(){if(t(".rc-option__subsave").length){if(void 0!==theme.settings.rechargeWidgetText)var o=`<div class="productlisttext" style="display: none;">${theme.settings.rechargeWidgetText}</div>`;t(".rc-option__subsave").append(o),t(".rc-radio__input").change(function(){"subsave"==t(this).val()?t(".rc-option__subsave .productlisttext").show():t(".rc-option__subsave .productlisttext").hide()}),t(".rc_popup").remove(),clearInterval(i)}},100)});
    
jQuery('.my-slider-v2').slick({
  infinite: false,
   dots: true,
  slidesToShow: 3,
  slidesToScroll: 1,
      prevArrow: '   <div class="prev"><img src="https://cdn.shopify.com/s/files/1/0580/6217/6407/files/slider-prev-opt.png?v=1696078256">    </div>   ',
    nextArrow: ' <div class="next"><img src="https://cdn.shopify.com/s/files/1/0580/6217/6407/files/slider-next-opt.png?v=1696078694">    </div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.20,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});